<template>
  <span>(<strong>{{drugData.currency_price * drugData.qty}}</strong> {{ currency.currency}})</span>
</template>

<script>
export default {
  props: ['drugData', 'currency']
}
</script>
